module.exports = __webpack_public_path__ + "img/32.595d8344.png";